var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { nrDataMapper } from "@domains/salesFeatures/NRDashboard/mapper/NRDataMapper";
import { productDataMapper } from "@domains/salesFeatures/NRDashboard/mapper/ProductDataMapper";
import { nrHeaderDataMapper } from "@domains/salesFeatures/NRDashboard/mapper/NRHeaderDataMapper";
import NRDashboardUrlConfig from "@adapters/infrastructures/urlConfig/SalesJourney/NRDashboard/NRDashboardURL";
import { employeeDetailsMapper } from "@domains/salesFeatures/NRDashboard/mapper/EmployeeMapper";
import { locationDetailsMapper } from "@domains/salesFeatures/NRDashboard/mapper/LocationMapper";
import { removeObjectValues } from "@frameworks/salesjourney/components/Features/LeadDashboard/constant";
var NRDashboardRepository = /** @class */ (function () {
    function NRDashboardRepository(http) {
        this.http = http;
    }
    NRDashboardRepository.prototype.getNRSummary = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result, NRSummary;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.Summary);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("flag", localReqObj.flag);
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        NRSummary = {
                            data: result.data,
                        };
                        return [2 /*return*/, NRSummary];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getClientLevel = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result, nrClientLevel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.ClientLevel);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        nrClientLevel = {
                            data: result.data,
                        };
                        return [2 /*return*/, nrClientLevel];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getNRData = function (nrRequestPayload) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, nrDataReponse, nrDataEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.NRProductData);
                        localReqObj = JSON.parse(JSON.stringify(nrRequestPayload));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        nrDataReponse = _b.sent();
                        nrDataEntity = {
                            nrDataList: [],
                            totalData: [],
                            totalClientCountData: []
                        };
                        if (((_a = nrDataReponse === null || nrDataReponse === void 0 ? void 0 : nrDataReponse.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            nrDataEntity = nrDataMapper(nrDataReponse.data);
                        }
                        return [2 /*return*/, nrDataEntity];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getProductData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.PrdoutNRDashboard);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        url.searchParams.append("pageno", localReqObj.pageNo);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, productDataMapper(result.data, localReqObj)];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getEmployeeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.EmployeeNRDashboard);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        url.searchParams.append("empcode", localReqObj.empcode);
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, employeeDetailsMapper(result.data, localReqObj)];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getNRHeaderData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.HeaderNRDashboard);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, nrHeaderDataMapper(result.data)];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getLocationData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.Location);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("financialYr", localReqObj.financialYr);
                        url.searchParams.append("quater", localReqObj.quater);
                        url.searchParams.append("month", localReqObj.month);
                        url.searchParams.append("LobOrRm", localReqObj.LobOrRm);
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        localReqObj.zoneId
                            ? url.searchParams.append("zoneid", localReqObj.zoneId)
                            : null;
                        localReqObj.regionId
                            ? url.searchParams.append("regionid", localReqObj.regionId)
                            : null;
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, locationDetailsMapper(result.data, localReqObj)];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getFinancialYearData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.financialYear);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    NRDashboardRepository.prototype.getLobNRData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(NRDashboardUrlConfig.lobNR);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    return NRDashboardRepository;
}());
export default NRDashboardRepository;
